let buf = new Uint8Array(65536);
let pos = 0;
const decoder = new TextDecoder();
function ensure(n) {
  if (pos + n > buf.length) {
    const next = new Uint8Array(buf.length * 2);
    next.set(buf);
    buf = next;
  }
}
function resetPath() {
  pos = 0;
}
function writeStr(s) {
  ensure(s.length);
  for (let i = 0; i < s.length; i++) {
    buf[pos++] = s.charCodeAt(i);
  }
}
function writeC(n) {
  ensure(16);
  if (n < 0) {
    buf[pos++] = 45;
    n = -n;
  }
  const i = n / 100 | 0;
  const f = n - i * 100;
  if (i === 0) {
    if (f === 0) {
      buf[pos++] = 48;
      return;
    }
  } else if (i < 10) {
    buf[pos++] = 48 + i;
  } else if (i < 100) {
    buf[pos++] = 48 + (i / 10 | 0);
    buf[pos++] = 48 + i % 10;
  } else {
    const start = pos;
    let m = i;
    while (m > 0) {
      buf[pos++] = 48 + m % 10;
      m = m / 10 | 0;
    }
    let lo = start;
    let hi = pos - 1;
    while (lo < hi) {
      const t = buf[lo];
      buf[lo] = buf[hi];
      buf[hi] = t;
      lo++;
      hi--;
    }
  }
  if (f !== 0) {
    buf[pos++] = 46;
    const d2 = f % 10;
    buf[pos++] = 48 + (f / 10 | 0);
    if (d2 !== 0) {
      buf[pos++] = 48 + d2;
    }
  }
}
function writeCPair(nx, ny) {
  writeC(nx);
  buf[pos++] = 44;
  writeC(ny);
  buf[pos++] = 32;
}
function finishPath() {
  const s = decoder.decode(buf.subarray(0, pos));
  pos = 0;
  return s;
}
function toCenti(v) {
  return Math.round(v * 100);
}
export {
  finishPath,
  resetPath,
  toCenti,
  writeC,
  writeCPair,
  writeStr
};
//# sourceMappingURL=fmt.mjs.map
